import { useMemo } from "react";
import type { Email, TmsProviderCapabilities } from "@src/types/api";

const DEFAULT_CAPABILITIES: TmsProviderCapabilities = {
  id: "unknown",
  displayName: "TMS",
  supportsLTL: false,
  supportsFTL: false,
  bookingKind: "none",
  accessorials: [],
  documentsSupported: false,
};

export function useProviderConfig(emailData: Email | null): TmsProviderCapabilities {
  return useMemo(
    () => emailData?.organization?.tmsCapabilities ?? DEFAULT_CAPABILITIES,
    [emailData?.organization?.tmsCapabilities]
  );
}
